'use client';

import { c as _c } from "react/compiler-runtime";
import BackgroundImage from '@components/background-image/BackgroundImage';
import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import sportImg from '@images/renders/infrastructure_images/Infra_Desktop_Webp/sport.webp';
import sportImgMob from '@images/renders/infrastructure_images/Infra_Mobile_Webp/sport_mob.webp';
import { handleStartPanoramaPreload } from '@lib/store/slices/ComponentsSlice';
import { showAnimateMobile } from '@lib/tools/_show-animate-mobile';
import useOnScreen from '@lib/tools/hooks/useOnScreen';
import { useLayoutEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import style from './FifthScreenInfra.module.scss';
function FifthScreenInfraMobile(t0) {
  const $ = _c(14);
  const {
    isMobile
  } = t0;
  const dispatch = useDispatch();
  const svgRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const isVisible = useOnScreen(textRef, "50px");
  let t1;
  if ($[0] !== dispatch || $[1] !== isVisible) {
    t1 = () => {
      if (isVisible) {
        showAnimateMobile(titleRef);
        showAnimateMobile(textRef);
        dispatch(handleStartPanoramaPreload(true));
      }
    };
    $[0] = dispatch;
    $[1] = isVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isVisible) {
    t2 = [isVisible];
    $[3] = isVisible;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useLayoutEffect(t1, t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BackgroundImage className={style.thirdScreenImg} src={sportImg} src375={sportImgMob} name="bgr_5" imagePlug="" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isMobile) {
    t4 = isMobile && <div ref={titleRef} className={style.thirdScreenTitle}><p className="will-show">Вся семья </p><p className="will-show">на спорте</p></div>;
    $[6] = isMobile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <br />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div ref={textRef} className={style.thirdScreenDescription}><p className="will-show">Для здорового и спортивного образа{t5} жизни всё есть: зелёные спортивные площадки и зоны<br />для функциональных тренировок, настольного тенниса, баскетбол, лужайки для йоги и медитаций.</p></div>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={style.fiveScreenInfoImgWrapper}><ParallaxMedia speed={0.01} offset={-100} end={5000} video="/videos/autumn-pond.mp4" className={style.fifthScreenImgSmallMob} isVideo={true} /></div>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={style.thirdScreenBoxTextMob}><p>Предпочитаете длинные пробежки и велопрогулки? Стартуйте и финишируйте красиво — велодорожки по всему парку Покровское-Стрешнево.</p><p>Велостоянки предусмотрены везде, где захочется остановить мгновение или перейти на прогулочный шаг.</p></div>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4) {
    t9 = <div data-scroll={true} className={style.thirdScreenContainer} ref={svgRef} id="five">{t3}{t4}{t6}{t7}{t8}</div>;
    $[12] = t4;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  return t9;
}
export default FifthScreenInfraMobile;